import cloneDeep from 'lodash/cloneDeep';

export class Node {

  constructor({ id, value, parentId, children, displayObject }) {
    if (typeof id !== 'number') {
      throw new Error('Node constructor requires an id');
    }
    // if (parent && !(parent instanceof Node)) {
    //   throw new Error('Node constructor parent is not a Node');
    // }
    this.id = id;
    this.value = value instanceof Object ? value : {};
    // this.parent = parent ? parent : null;
    this.parentId = parentId;
    this.children = children ? children : [];
    this.displayObject = displayObject ? displayObject : null;
  }

  getDisplayObject() {
    return this.displayObject;
  }

  setDisplayObject(displayObject) {
    this.displayObject = displayObject;
  }

  addChild(child) {
    if (child && child instanceof Node) {
      if (this.contains(child)) {
        throw new Error('Cannot add duplicate child to node');
      }
      // child.parent = this;
      child.parentId = this.id;
      this.children.push(child);
    } else {
      throw new Error('child must be a node');
    }
  }

  contains(node) {
    let current = this;
    const queue = [current];
    while (queue.length) {
      current = queue.shift();
      if (current === node) {
        return true;
      }
      current.children.forEach(child => {
        queue.push(child);
      });
    }
    return false;
  }

  removeChild(id) {
    const index = this.children.findIndex(child => child.id === id);
    if (index < 0) {
      return false;
    }
    return this.children.splice(index, 1)[0];
  }

  /**
   * If a node is is in tweenIds, then keep the current display object,
   * else when a new node is constructed, it's display object is null
   * @param tweenIds
   * @returns {Node}
   */
  clone({ tweenItems = [] }) {
    const tweenIds = tweenItems.map(item => item.id);
    let value;
    if (this.value && typeof this.value === 'object') {
      value = cloneDeep(this.value);
    } else {
      value = this.value;
    }
    let d = null;
    if (tweenIds.includes(this.id) && this.displayObject ) {
      d = this.displayObject;
    }
    let children = this.children
      .map(child => {
        return child.clone({ tweenItems });
      });
    children = children || [];
    return new Node({
      id: this.id,
      value,
      // parent: this.parent,
      parentId: this.parentId,
      children,
      displayObject: d
    });
  }
}

/**
 * Root node is the stage
 * Set value to null, since it will be constructed anew in graphics/cjs-reduxloadTree
 */
export class Tree {

  /**
   *
   * @param {Node | null} node
   */
  constructor(node) {
    this.map = new IdMap();
    /**
     * @type {Node}
     */
    if (node instanceof Node) {
      this.root = node;
      const queue = [node];
      let current;
      while (queue.length) {
        current = queue.shift();
        this.map.set(current.id, current);
        current.children.forEach(child => {
          queue.push(child);
        });
      }
    } else {
      this.root = new Node({ id: 0, value: null });
      this.map.set(0, this.root);
    }
    this.stage = null;
    /*
    this.root = null;
    if (root && root instanceof Node) {
      this.root = root;
    } else if (root) {
      this.root = new Node({value: root});
    }
    */
  }

  setStage(stage) {
    this.stage = stage;
  }

  set({ parentId, id, value }) {
    const parent = this.map.get(parentId);
    if (!parent) {
      throw new Error(`Tree.add parentId ${parentId} does not exist`);
    }
    if (this.contains(id)) {
      console.log(`id ${id} already in Tree`);
      return;
    }
    let node;
    if (value && value instanceof Node) {
      node = value;
    } else {
      node = new Node({parentId, id, value});
    }
    parent.addChild(node);
    this.map.set(id, node);
  }

  get(id) {
    return this.map.get(id);
  }

  contains(id) {
    return !!this.map.contains(id);
  }

  remove(id) {
    if (id === 0 || !this.map.contains(id)) {
      return false;
    }
    const node = this.map.get(id);
    const parent = this.map.get(node.parentId);
    if (!parent) {
      console.log(`Tree remove ${id} failed: parent ${node.parentId} is not in Tree`);
      return;
    }
    this.map.remove(id);
    parent.removeChild(id);
    return node;
  }

  updateValue({id, value}) {
    if (this.map.contains(id)) {
      const node = this.map.get(id);
      node.value = value;
      return node;
    }
    return false;
  }

  clone({ tweenItems = [] }) {
    const newRoot = this.root.clone({ tweenItems });
    return new Tree(newRoot);
  }

}

export class IdMap {

  constructor(map) {
    if (map && map instanceof Object) {
      this.map = map;
    } else {
      this.map = {};
    }
  }

  contains(id) {
    return !!this.map[id];
  }

  get(key) {
    return this.map[key];
  }

  set(key, value) {
    this.map[key] = value;
  }

  remove(key) {
    const node = this.map[key];
    delete this.map[key];
    return node;
  }

  clone() {
    return new IdMap(Object.assign({}, {...this.map}));
  }
}

